// extracted by mini-css-extract-plugin
export default {"list":"style_list__TREFU","list_item":"style_list_item__P6X-i","img":"style_img__bHfPU","title":"style_title__ZvQZ5","text":"style_text__o68Ry","heading":"style_heading__a7hXv"};